var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgVideo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 64 64",
    height: "64px",
    viewBox: "0 0 64 64",
    width: "64px",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 31.833,
    cy: 32,
    fill: "#C75C5C",
    r: 32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#4F5D73",
    height: 4,
    width: 4,
    x: 16,
    y: 30
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#4F5D73",
    height: 4,
    width: 4,
    x: 16,
    y: 37
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#4F5D73",
    height: 4,
    width: 4,
    x: 16,
    y: 44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#4F5D73",
    height: 4,
    width: 4,
    x: 16,
    y: 23
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#4F5D73",
    height: 4,
    width: 4,
    x: 16,
    y: 16
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#4F5D73",
    height: 4,
    width: 4,
    x: 44,
    y: 30
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#4F5D73",
    height: 4,
    width: 4,
    x: 44,
    y: 37
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#4F5D73",
    height: 4,
    width: 4,
    x: 44,
    y: 44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#4F5D73",
    height: 4,
    width: 4,
    x: 44,
    y: 23
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#4F5D73",
    height: 4,
    width: 4,
    x: 44,
    y: 16
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#4F5D73",
    height: 14,
    width: 16,
    x: 24,
    y: 16
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#4F5D73",
    height: 14,
    width: 16,
    x: 24,
    y: 34
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48,14H16c-2.209,0-4,1.791-4,4v32c0,2.209,1.791,4,4,4h32c2.209,0,4-1.791,4-4V18    C52,15.791,50.209,14,48,14z M20,50h-4v-4h4V50z M20,43h-4v-4h4V43z M20,36h-4v-4h4V36z M20,29h-4v-4h4V29z M20,22h-4v-4h4V22z     M40,50H24V36h16V50z M40,32H24V18h16V32z M48,50h-4v-4h4V50z M48,43h-4v-4h4V43z M48,36h-4v-4h4V36z M48,29h-4v-4h4V29z M48,22    h-4v-4h4V22z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48,12H16c-2.209,0-4,1.791-4,4v32c0,2.209,1.791,4,4,4h32c2.209,0,4-1.791,4-4V16    C52,13.791,50.209,12,48,12z M20,48h-4v-4h4V48z M20,41h-4v-4h4V41z M20,34h-4v-4h4V34z M20,27h-4v-4h4V27z M20,20h-4v-4h4V20z     M40,48H24V34h16V48z M40,30H24V16h16V30z M48,48h-4v-4h4V48z M48,41h-4v-4h4V41z M48,34h-4v-4h4V34z M48,27h-4v-4h4V27z M48,20    h-4v-4h4V20z",
    fill: "#E0E0D1"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVideo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/video.1e69f67f.svg";
export { ForwardRef as ReactComponent };